<template>
  <div class="providers">
    <div class="search">
      <el-autocomplete
        v-model="search"
        :fetch-suggestions="querySearchAsync"
        :trigger-on-focus="false"
        :placeholder="$t('providers.search')"
        @select="handleSelect"
      >
        <svg-icon slot="prefix" name="search" />
        <svg-icon v-if="search.length" slot="suffix" name="close" @click="resetSelect" />
      </el-autocomplete>
    </div>

    <div class="scrollbar">
      <div
        v-for="provider in providers"
        :key="provider.id"
        :class="{'selected': selected && provider.id === selected.id}"
        class="provider"
        @click="selectProvider(provider)"
      >
        <el-row>
          <el-col :span="2" class="avatar">
            <el-avatar icon="el-icon-user-solid" :src="provider.profile.avatar | avatar64" />
          </el-col>
          <el-col :span="20">
            <div class="name">
              {{ provider.profile.name }}
            </div>
            <span class="hunter">
              {{ $t('hunters.title') }}: <b>{{ getHunterName(provider) }}</b>
            </span>
          </el-col>
        </el-row>
      </div>
    </div>

    <ts-pagination
      :total="total"
      :page-size="10"
      @current-change="changePage"
    />
  </div>
</template>

<script>
  import { getProviders } from '@/api/providers'
  import Pagination from '@/components/Pagination.vue'

  export default {
    components: {
      'ts-pagination': Pagination
    },

    props: {
      selected: Object
    },

    data() {
      return {
        page: 1,
        search: ''
      }
    },

    computed: {
      providers() {
        return this.$store.state.Providers.list
      },

      total() {
        return this.$store.state.Providers.total
      }
    },

    created() {
      this.getList()
    },

    methods: {
      getList() {
        this.$store.dispatch('Providers/getProviders', {
          page: this.page,
          query: this.search
        })
      },

      changePage(page) {
        this.page = page
        this.getList()
      },

      selectProvider(provider) {
        this.$emit('provider-change', provider)
      },

      getHunterName(provider) {
        return provider.profile.hunter
          ? provider.profile.hunter.profile.name
          : ''
      },

      async querySearchAsync(queryString, cb) {
        const { data } = await getProviders({
          page: 1,
          query: queryString
        })

        const list = data.data.map(item => {
          return {
            value: item.profile.name
          }
        })

        cb(list)
      },

      resetSelect() {
        this.search = ''
        this.$store.dispatch('Providers/getProviders', {
          page: 1,
          query: ''
        })
      },

      handleSelect(item) {
        this.$store.dispatch('Providers/getProviders', {
          page: 1,
          query: item.value
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .providers {
    position: absolute;
    top: 30px;
    right: 15px;
    bottom: 30px;
    left: 0;
    z-index: 500;

    .scrollbar {
      height: 80%;
    }

    .search {
      margin-bottom: 20px;
    }

    .provider {
      border-bottom: 1px solid $border-color-light;
      padding: 20px 0;
      cursor: pointer;

      .avatar {
        min-width: 60px;
        padding-top: 5px;
        color: white;
        border: 2px solid white;
      }

      .name {
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        color: $color-text-regular;
      }

      .hunter {
        font-size: 13px;
        line-height: 24px;
        color: $color-text-placeholder;

        b {
          font-weight: 500;
        }
      }

      &.selected {
        .avatar {
          .el-avatar {
            border: 2px solid $color-primary;
          }
        }

        .name, .hunter {
          color: $color-primary
        }
      }
    }
  }
</style>
